module.exports = __webpack_public_path__ + "static/logo-77628929a27bb7bdcf2d5650252a78e2.png";